<template>
  <div class="customer_feedback">
    <b-container fluid>
      <div class="top-row">
        <span class="top-row-name">Delivery Docket</span>
        <b-button class="top-row-button" variant="success" @click="createReport()">Add</b-button>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'CustomerFeedback',
  date() {
    return {
      tableFields: [
        
      ],
    }
  },
  props: {
    user: Object,

  },
  methods: {
    
  }
}
</script>

<style>

</style>